import type { IconAsset } from '../Icon.types';

const code = (
  <>
    <g clipPath='url(#clip0_42634_199408)'>
      <g clipPath='url(#clip1_42634_199408)'>
        <path
          d='M17.4913 2H6.50875C4.01864 2 2 4.01864 2 6.50875V17.4913C2 19.9814 4.01864 22 6.50875 22H17.4913C19.9814 22 22 19.9814 22 17.4913V6.50875C22 4.01864 19.9814 2 17.4913 2Z'
          fill='white'
        />
        <path
          d='M18.6662 11.0575C18.6662 8.07374 15.675 5.64624 11.9981 5.64624C8.32121 5.64624 5.32996 8.07374 5.32996 11.0575C5.32996 13.7325 7.70246 15.9725 10.9068 16.3962C11.1237 16.4431 11.4193 16.5394 11.4943 16.725C11.5618 16.8937 11.5381 17.1575 11.5162 17.3281C11.5162 17.3281 11.4381 17.7987 11.4212 17.8987C11.3918 18.0675 11.2875 18.5581 11.9987 18.2581C12.7106 17.9581 15.8387 15.9969 17.2375 14.3869C18.2037 13.3269 18.6668 12.2519 18.6668 11.0575H18.6662Z'
          fill='black'
        />
        <path
          d='M16.4475 12.7806H14.5744C14.5038 12.7806 14.4469 12.7237 14.4469 12.6531V12.6512V9.74623V9.7431C14.4469 9.67248 14.5038 9.6156 14.5744 9.6156H16.4475C16.5175 9.6156 16.575 9.6731 16.575 9.7431V10.2162C16.575 10.2869 16.5182 10.3437 16.4475 10.3437H15.1744V10.835H16.4475C16.5175 10.835 16.575 10.8925 16.575 10.9625V11.4356C16.575 11.5062 16.5182 11.5631 16.4475 11.5631H15.1744V12.0544H16.4475C16.5175 12.0544 16.575 12.1119 16.575 12.1819V12.655C16.575 12.7256 16.5182 12.7825 16.4475 12.7825V12.7806Z'
          fill='white'
        />
        <path
          d='M9.5181 12.7806C9.5881 12.7806 9.6456 12.7237 9.6456 12.6531V12.18C9.6456 12.11 9.5881 12.0525 9.5181 12.0525H8.24497V9.74249C8.24497 9.67249 8.18747 9.61499 8.11747 9.61499H7.64435C7.57372 9.61499 7.51685 9.67187 7.51685 9.74249V12.6506V12.6531C7.51685 12.7237 7.57372 12.7806 7.64435 12.7806H9.51747H9.5181Z'
          fill='white'
        />
        <path
          d='M10.6457 9.6156H10.1732C10.1027 9.6156 10.0457 9.67268 10.0457 9.7431V12.6531C10.0457 12.7235 10.1027 12.7806 10.1732 12.7806H10.6457C10.7161 12.7806 10.7732 12.7235 10.7732 12.6531V9.7431C10.7732 9.67268 10.7161 9.6156 10.6457 9.6156Z'
          fill='white'
        />
        <path
          d='M13.865 9.6156H13.3919C13.3213 9.6156 13.2644 9.67248 13.2644 9.7431V11.4712L11.9331 9.6731C11.93 9.66873 11.9263 9.66435 11.9232 9.65998C11.9232 9.65998 11.9231 9.65998 11.9225 9.65935C11.92 9.65685 11.9175 9.65373 11.915 9.65123C11.9144 9.6506 11.9132 9.64998 11.9125 9.64935C11.91 9.64748 11.9082 9.6456 11.9057 9.64373C11.9044 9.6431 11.9031 9.64185 11.9019 9.64123C11.9 9.63935 11.8975 9.6381 11.895 9.63685C11.8938 9.63623 11.8925 9.63498 11.8913 9.63435C11.8888 9.6331 11.8869 9.63185 11.8844 9.6306C11.8831 9.62998 11.8819 9.62935 11.8806 9.62873C11.8781 9.62748 11.8756 9.62623 11.8731 9.6256C11.8719 9.6256 11.8706 9.62435 11.8688 9.62435C11.8663 9.62373 11.8638 9.62248 11.8613 9.62185C11.86 9.62185 11.8582 9.62123 11.8569 9.6206C11.8544 9.6206 11.8519 9.61935 11.8494 9.61873C11.8475 9.61873 11.8456 9.61873 11.8438 9.6181C11.8413 9.6181 11.8394 9.61748 11.8369 9.61748C11.8344 9.61748 11.8325 9.61748 11.83 9.61748C11.8288 9.61748 11.8269 9.61748 11.8257 9.61748H11.3556C11.2856 9.61748 11.2281 9.67435 11.2281 9.74498V12.655C11.2281 12.725 11.285 12.7825 11.3556 12.7825H11.8288C11.8994 12.7825 11.9563 12.7256 11.9563 12.655V10.9269L13.2894 12.7275C13.2988 12.7406 13.31 12.7512 13.3225 12.7594C13.3225 12.7594 13.3238 12.76 13.3238 12.7606C13.3263 12.7625 13.3288 12.7637 13.3319 12.7656C13.3331 12.7662 13.3344 12.7669 13.3356 12.7675C13.3375 12.7687 13.34 12.7694 13.3419 12.7706C13.3438 12.7719 13.3463 12.7725 13.3482 12.7731C13.3494 12.7731 13.3506 12.7744 13.3519 12.7744C13.355 12.7756 13.3575 12.7762 13.3606 12.7769C13.3606 12.7769 13.3619 12.7769 13.3625 12.7769C13.3731 12.7794 13.3844 12.7812 13.3956 12.7812H13.8657C13.9357 12.7812 13.9931 12.7244 13.9931 12.6537V9.74373C13.9931 9.67373 13.9363 9.61623 13.8657 9.61623L13.865 9.6156Z'
          fill='white'
        />
      </g>
    </g>
    <defs>
      <clipPath id='clip0_42634_199408'>
        <rect fill='white' height='24' width='24' />
      </clipPath>
      <clipPath id='clip1_42634_199408'>
        <rect fill='white' height='20' transform='translate(2 2)' width='20' />
      </clipPath>
    </defs>
  </>
);
export const line: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
